const e = "清除搜索字段", l = "选择选项", a = {
  clearSearch: e,
  selectPlaceholder: l,
  "Select.InputSearch.Value:placeholder": "搜索",
  "Select.InputSearch.Value:aria-label": "搜索"
};
export {
  e as clearSearch,
  a as default,
  l as selectPlaceholder
};
